/**
 * Institution shape consumed by registration.
 *
 * Single source of truth lives in the institutions data hook module
 * (`@/data/useInstitutions`, ported from the Angular InstitutionsService).
 * Re-exported here for the registration model's consumers.
 */
import type { Institution } from '@/data/useInstitutions';

export type { Institution };

export interface RegistrationData {
  // Institution Information
  institution: Institution | null;
  customInstitution: string;

  // Personal Information
  firstName: string;
  lastName: string;
  suffix: string;
  title: string;

  // Professional Information
  npi: string;
  dea: string;

  // Account Information
  username: string;
  email: string;
  password: string;

  // Preferences
  enableFacialRecognition: boolean;
  role: string;
  specialty?: string;

  // Timestamps
  registrationDate: Date;
  lastUpdated: Date;
}

export interface FacialRecognitionData {
  frontPhoto?: string;
  leftSidePhoto?: string;
  rightSidePhoto?: string;
  setupCompleted: boolean;
  setupDate?: Date;
}

export const TITLE_OPTIONS = [
  'Prof.',
  'Doctor',
  'NP',
  'RN',
  'Sir',
  'Mrs.',
  'Ms.',
  'Mr.'
];

export const SUFFIX_OPTIONS = [
  'MD',
  'DO',
  'PhD',
  'MBA',
  'MSB',
  'MSN',
  'BSN',
  'RN',
  'NP',
  'PA-C',
  'PharmD',
  'DPT',
  'OTR/L',
  'LCSW',
  'MPH',
  'MS',
  'MA',
  'BS',
  'BA'
];
